import { render, staticRenderFns } from "./translatable-modal.vue?vue&type=template&id=3837760a&scoped=true&"
import script from "./translatable-modal.vue?vue&type=script&lang=ts&"
export * from "./translatable-modal.vue?vue&type=script&lang=ts&"
import style0 from "./translatable-modal.vue?vue&type=style&index=0&id=3837760a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3837760a",
  null
  
)

export default component.exports